import { handleActions } from 'redux-actions'
import { Record, List } from 'immutable'
// @ts-ignore
import isEqual from 'lodash/isEqual'
import { REHYDRATE } from 'redux-persist'

import { offline } from './actions'

import { IOfflineRecord, IOffline } from './interface'

export const Offline = Record<IOffline>(
  {
    isOffline: false,
    isWaiting: false,
    waitingList: List(),
    lastAction: undefined,
  },
  'Offline'
)

const rehydrate = (state: IOfflineRecord, { payload }: any) => {
  return payload && payload.offline && payload.offline.set
    ? payload.offline
        .set('isWaiting', false)
        .set('waitingList', List())
        .set('lastAction', undefined)
    : state
}

const addToWaiting = (state: IOfflineRecord, { payload: { action } }: any) => {
  // if action already exists, than do nothing
  if (isEqual(action, state.get('lastAction'))) {
    return state
  }
  const indexInTheQueue = state.get('waitingList').findIndex(val => isEqual(val, action))
  if (~indexInTheQueue) {
    return state.set('waitingList', state.get('waitingList').set(indexInTheQueue, action))
  }
  return state
    .set('isWaiting', true)
    .set('isOffline', false)
    .set('waitingList', state.get('waitingList').push(action))
}

const shiftFirst = (state: IOfflineRecord) => {
  const action = state.get('waitingList').first()
  return state
    .set('waitingList', state.get('waitingList').shift())
    .set('isWaiting', !!action)
    .set('lastAction', action)
}

const startWaiting = (state: IOfflineRecord, { payload: { action } }: any) => {
  return state
    .set('isWaiting', true)
    .set('isOffline', false)
    .set('lastAction', action)
}

const setOffline = (state: IOfflineRecord, { payload: { isOffline } }: any) => {
  if (isOffline) {
    return state
      .set('isOffline', isOffline)
      .set('lastAction', undefined)
      .set('waitingList', List())
  }
  return state.set('isOffline', isOffline)
}

export default handleActions(
  {
    [REHYDRATE]: rehydrate,
    [offline.addToWaiting]: addToWaiting,
    [offline.shiftFirst]: shiftFirst,
    [offline.startWaiting]: startWaiting,
    [offline.setOffline]: setOffline,
  },
  new Offline()
)
